import { Button } from '@mui/material'
import styled from 'styled-components'

export const ButtonUiKitStyled = styled(Button)`
min-width: 34px !important;
height: 34px !important;
  border-radius: 10px !important;
   box-shadow: none !important;
  color: #fff  !important;
  &:hover {
    background-color: rgb(0, 0, 0);
  }
`
